import {BETimelineUpdateCommand} from './types';
import performQuery, {Middleware} from './performQuery';
import {createMiddleware} from './utils';

/**
 * Performs a GraphQL query that retrieves the timeline command events of a defined day
 * @param sportEventId
 * @param id the id of the last retrieved command
 */
const timelineUpdateCommandsByEventAndId = (
  sportEventId: string,
  id?: string
): Promise<BETimelineUpdateCommand[]> => {
  const getRoot: Middleware = createMiddleware('timeEventCommandsBySportEvent');
  const query = `{
    timeEventCommandsBySportEvent(id:"${sportEventId}", after:"${id || ''}") {
      _id
      sportEventId
      commandType
      timeEvent {
        _id
        timeLineEventId
        matchTime
        eventOutcome
        competitorIdentifier
        stoppageTime
        stoppageTimeShown
        homeScore
        awayScore
        server
        result
        points
        period
        periodName
        pictureUrl
        pictureCaption
        embed
        openTitle
        content
        sponsoredLink
        sportEventId
        localDateTime
        method
        eventTag {
          keyword
          displayName
        }
        players {
          sportRadarPlayerId
          name
        }
        user {
          fullname
          logoUrl
        }
        relatedVideo
        isArchived
        isPinned
      }
    }
  }`;

  return performQuery(query, getRoot)();
};

export default timelineUpdateCommandsByEventAndId;
